var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943 2061 c-100 -29 -170 -70 -232 -137 -68 -73 -101 -153 -101 -246 0 -52 -3 -59 -23 -67 -34 -13 -75 -66 -83 -106 -3 -19 -4 -74 -3 -124 3 -71 8 -95 25 -117 31 -43 67 -65 112 -71 l41 -5 3 278 3 279 28 57 c64 131 217 208 412 208 195 0 348 -77 412 -208 l28 -57 3 -279 3 -278 41 5 c45 6 81 28 112 71 17 22 22 46 25 117 1 50 0 105 -3 124 -8 39 -49 93 -81 105 -20 8 -23 17 -27 87 -11 181 -134 313 -343 368 -82 21 -271 19 -352 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 1881 c-97 -36 -169 -105 -199 -192 -23 -67 -26 -288 -5 -392 12 -60 18 -71 55 -102 81 -66 125 -79 263 -76 113 2 122 1 132 -18 33 -61 -3 -91 -110 -91 -61 0 -81 4 -102 20 -14 11 -31 20 -39 20 -7 0 -42 14 -76 30 -35 17 -66 30 -68 30 -9 0 46 -98 71 -128 l26 -31 -192 -97 c-174 -88 -199 -104 -263 -169 -97 -97 -151 -203 -170 -338 -8 -59 29 -93 124 -112 370 -77 816 -90 1195 -36 334 48 354 60 329 191 -21 113 -72 208 -158 294 -66 66 -90 81 -264 170 l-192 97 29 37 c42 52 77 134 108 249 34 129 39 366 10 450 -25 70 -93 145 -165 180 -50 24 -71 28 -172 30 -94 3 -124 0 -167 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fd606aa32c14470b7575cf4ef3a2315d.svg";
export { ForwardRef as ReactComponent };